import React from 'react'
import { useSelector } from 'react-redux'
import { selectDelivery, setDelivery } from '../filterSlice'
import Radio from '../base/Radio'

const Delivery = () => {
    const delivery = useSelector(selectDelivery)

    const data = [
        { val: 'now', name: 'Сегодня' },
        { val: 'tomorrow', name: 'Завтра' },
        { val: 'five', name: 'До 5 дней' },
        { val: 'any', name: 'Любой' }
    ]

    return (
        <Radio name={'Срок доставки'} defaultChecked={delivery} action={setDelivery} data={data} />
    )
}

export default Delivery
